// Navigation sections used in Navbar and Footer
export const sections = [
  { id: 'landing', text: 'Landing' },
  { id: 'location', text: 'Location' },
  { id: 'sessions', text: 'Sessions' },
  { id: 'speakers', text: 'Speakers' },
  { id: 'jobboard', text: 'Job Board' },
  { id: 'partners', text: 'Partners' },
  { id: 'devteam', text: 'DevFest Team' },
]

export const externalLinks = [
  { to: '/previous-events', text: 'Previous Events' },
]
